export default __webpack_public_path__ + "static/butler-light-73f35be5f5758a25d7a44b9532ccb6d0.woff2";